import { render, staticRenderFns } from "./RetoureSettingsModal.vue?vue&type=template&id=18d04a97&scoped=true"
import script from "./RetoureSettingsModal.vue?vue&type=script&lang=js"
export * from "./RetoureSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./RetoureSettingsModal.vue?vue&type=style&index=0&id=18d04a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d04a97",
  null
  
)

export default component.exports